export default {
    // configuration: true,
    searchList: {
        searchTxt: [
            {
                name: '绩效单据编码',
                value: 'performanceCode',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '月份',
                value: 'assessmentMonthList',
                type: 'time',
                timeType: 'monthrange',
                format: 'yyyy-MM',
                startPlaceholder: '开始月份',
                endPlaceholder: '结束月份',
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一个月',
                            onClick(picker) {
                                const start = dayjs().startOf('month').subtract(0, 'M').toDate()
                                const end = dayjs().endOf('month').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近三个月',
                            onClick(picker) {
                                const start = dayjs().startOf('month').subtract(2, 'M').toDate()
                                const end = dayjs().endOf('month').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                        {
                            text: '最近一年',
                            onClick(picker) {
                                const start = dayjs().startOf('month').subtract(11, 'M').toDate()
                                const end = dayjs().endOf('month').toDate()
                                picker.$emit('pick', [start, end])
                            },
                        },
                    ],
                },
                unfold: true,
                span: 8,
            },
            {
                name: '运作质量',
                value: 'recalculateOperationalQualityList',
                type: 'select',
                unfold: true,
                multiple: true,
                span: 5,
                optionNum: 'SRM_OPERATIONAL_QUALITY',
            },
        ],
        unfoldState: false,
        advancedBtn: false,
    },
    table: {
        // switchType: true,
        // tableCut: false,
        // clickState: false,
        // selectBtn: true,
        height: 'calc(100vh - 170px)',
        columns: [
            {
                label: '绩效单据编码',
                prop: 'performanceCode',
                width: '150px',
            },
            {
                label: '考核月份',
                prop: 'assessmentMonth',
                width: '100px',
            },
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '供应商名称',
                prop: 'supplierName',
                width: '140px',
            },
            {
                label: '考核得分',
                prop: 'assessmentScore',
                // info: '异常得分+KPI考核得分',
                width: '100px',
            },
            {
                label: '异常考核得分',
                prop: 'abnormalAssessmentScore',
                width: '100px',
            },
            {
                label: 'KPI考核得分',
                prop: 'kpiAssessmentScore',
                width: '100px',
            },
            {
                label: '运作质量',
                prop: 'recalculateOperationalQuality',
                type: 'select',
                optionNum: 'SRM_OPERATIONAL_QUALITY',
                options: [],
                // info: '<div>考核得分≥90 赋值为【正常】</div><div>考核得分含80-90 赋值为【整改】</div><div>考核得分函60-80 赋值为【整改约谈】</div><div>考核得分＜60 赋值为【运作风险】</div>',
                width: '100px',
            },
            {
                label: '月罚扣款/元',
                prop: 'monthlyPenaltyDeduction',
                // info: '<div>1）数据来源：BMS-计费数据-供应商罚扣款-供应商罚扣款信息-不含税金额</div><div>2）定义：以仓库+供应商对供应商罚扣款-不含税金额进行数据汇总</div>',
                width: '100px',
            },
            {
                label: '分公司',
                prop: 'companyName',
                width: '100px',
            },
            {
                label: '经营中心',
                prop: 'centerName',
                width: '100px',
            },
            {
                label: '质量损失率（%）',
                prop: 'qualityLossRate',
                width: '130px',
            },
            {
                label: '质量损失率得分',
                prop: 'qualityLossScore',
                width: '130px',
            },
            {
                label: '出库-及时单量',
                prop: 'outboundTimelyOrders',
                width: '120px',
            },
            {
                label: '出库-总单量（不含剔除）',
                prop: 'outboundTotalOrders',
                width: '170px',
            },
            {
                label: '出库及时率（%）',
                prop: 'outboundTimelyRate',
                width: '130px',
            },
            {
                label: '出库及时率（得分）',
                prop: 'outboundTimelyScore',
                width: '150px',
            },
            {
                label: '入库-及时订单量',
                prop: 'inboundTimelyOrders',
                width: '130px',
            },
            {
                label: '入库-总单量（不含剔除）',
                prop: 'inboundTotalOrders',
                width: '170px',
            },
            {
                label: '入库及时率（%）',
                prop: 'inboundTimelyRate',
                width: '130px',
            },
            {
                label: '入库及时率得分',
                prop: 'inboundTimelyScore',
                width: '130px',
            },
            {
                label: '在职人员',
                prop: 'activeEmployees',
                width: '100px',
            },
            {
                label: '离职人员',
                prop: 'resignedEmployees',
                width: '100px',
            },
            {
                label: '离职率（%）',
                prop: 'resignationRate',
                width: '100px',
            },
            {
                label: '离职率得分',
                prop: 'resignationRateScore',
                width: '100px',
            },
            {
                label: 'EHS(安全事故)',
                prop: 'ehsScore',
                width: '130px',
            },
            {
                label: '稽查',
                prop: 'auditScore',
                width: '100px',
            },
            {
                label: '客户投诉',
                prop: 'customerComplaints',
                width: '100px',
            },
            {
                label: '重大异常',
                prop: 'majorExceptions',
                width: '100px',
            },
            {
                label: '客户表扬',
                prop: 'customerPraise',
                width: '100px',
            },
            {
                label: '整改附件',
                prop: 'supplierLspMipAttachmentFileUrl',
                type: 'buttonList',
                buttonList: ['查看', '下载'],
                width: '90px',
            },
            {
                label: '审批状态',
                prop: 'supplierLspMipAuditStatus',
                type: 'select',
                optionNum: 'SRM_AUDIT_STATUS',
                options: [],
                width: '100px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '上传整改附件',
                size: 'small',
                event: 'attach',
                // ifHas: '/largeWhBillModel-30',
            },
            {
                type: 'text',
                label: '流程信息',
                size: 'small',
                event: 'audit',
                // ifHas: '/largeWhBillModel-40',
            },
        ],
        leftOperation: true,
        leftWidth: 180,
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
